import {
  createCatalogEndpoint,
  createCrudEndpoints,
  createExportEndpoint,
} from '@/core/utils'
import { TArticle } from '.'
import { DataWithPagination, TBaseCatalogs } from '@/core/types'

export type TArticles = DataWithPagination<TArticle>

export const serviceConfig = {
  model: 'articles',
  version: 'v1',
  catalogs: {
    categories: {
      model: undefined,
      version: 'v1',
    },
  },
}

const { categories } = serviceConfig.catalogs

const moduleServiceHandlers = createCrudEndpoints<TArticles, TArticle>(
  serviceConfig.model,
  serviceConfig.version,
)
const moduleExportHandlers = createExportEndpoint(serviceConfig.model)

const categoriesCatalog = createCatalogEndpoint<TBaseCatalogs>(
  categories.model,
  categories.version,
)

const catalogServiceHandlers = {
  categoriesCatalog,
}

export { moduleServiceHandlers, moduleExportHandlers, catalogServiceHandlers }
